import { createReducer, on } from '@ngrx/store';

import { ITimezone } from '@interfaces/timezones.interface';

import { loadTimezones, loadTimezonesSuccess, loadTimezonesError } from './timezones.actions';

export const timezonesFeatureKey = 'timezones';

export interface ITimezonesState {
  timezones: ITimezone[];
  fetching: boolean;
  error: boolean;
}

export const initialState: ITimezonesState = {
  timezones: [],
  fetching: false,
  error: false,
};

export const timezonesReducer = createReducer(
  initialState,
  on(loadTimezones, state => ({
    ...state,
    fetching: true,
    error: false,
  })),
  on(loadTimezonesSuccess, (state, { timezones }) => ({
    ...state,
    timezones,
    fetching: false,
    error: false,
  })),
  on(loadTimezonesError, state => ({
    ...state,
    fetching: false,
    error: true,
  })),
);
